import { render, staticRenderFns } from "./AutoDMs.vue?vue&type=template&id=5bb23627&"
import script from "./AutoDMs.vue?vue&type=script&lang=js&"
export * from "./AutoDMs.vue?vue&type=script&lang=js&"
import style0 from "./AutoDMs.vue?vue&type=style&index=0&id=5bb23627&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports